interface User {
  name?: string | null;
}
export const avatarPlaceholder = ({ name }: User) =>
  `https://ui-avatars.com/api/?name=${name}&background=2d88ff&color=fff`;

export const avatarPlaceholderAdventurer = (identity: string) =>
  `https://api.dicebear.com/9.x/adventurer-neutral/svg?radius=50&seed=${identity}`;

export const serverPlaceholder = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => `https://picsum.photos/${width}/${height}/355/?blur`;
